var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header dash-card-header row flex-shrink-0"},_vm._l((_vm.items),function(item){return _c('lambo-header-item',{key:item.kpi,class:[ ...item.classes ],attrs:{"dashdata":_vm.dashdata,"kpi":_vm.getKpiByString(item.kpi)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }